/**
 * This file is autogenerated by py_nats_stub_gen
 * Do not edit this file manually!!
 * => Instead, re-generate it. Check the py-nats-stub-gen repo for more info
 **/
import type { ApiSubscription, ApiSubscribe } from "../wire/ApiSubscriber";
import type { SessionApiHandler } from "./Handler";
import {
  linkCreatedEventSchema,
  linkDeletedEventSchema,
  settingUpdatedEventSchema,
  timersUpdatedEventSchema,
} from "./schemas";

export const subscribeSession: ApiSubscribe<SessionApiHandler> = (
  subscriber,
  variables,
  handler,
) => {
  const subscriptions = new Array<ApiSubscription>();
  if (handler.settingUpdated) {
    subscriptions.push(
      subscriber.subscribe(
        {
          template:
            "pip.${companyId}.${userId}.${role}.pubsub.session.v1.sessions.${sessionId}.setting.updated",
          variables,
          types: { sessionId: String },
        },
        settingUpdatedEventSchema,
        handler.settingUpdated,
        [],
      ),
    );
  }
  if (handler.linkCreated) {
    subscriptions.push(
      subscriber.subscribe(
        {
          template:
            "pip.${companyId}.${userId}.${role}.pubsub.session.v1.sessions.${sessionId}.link.created",
          variables,
          types: { sessionId: String },
        },
        linkCreatedEventSchema,
        handler.linkCreated,
        [],
      ),
    );
  }
  if (handler.linkDeleted) {
    subscriptions.push(
      subscriber.subscribe(
        {
          template:
            "pip.${companyId}.${userId}.${role}.pubsub.session.v1.sessions.${sessionId}.link.deleted",
          variables,
          types: { sessionId: String },
        },
        linkDeletedEventSchema,
        handler.linkDeleted,
        [],
      ),
    );
  }
  if (handler.timersUpdated) {
    subscriptions.push(
      subscriber.subscribe(
        {
          template:
            "pip.${companyId}.${userId}.${role}.pubsub.session.v1.sessions.${sessionId}.timers.updated",
          variables,
          types: { sessionId: String },
        },
        timersUpdatedEventSchema,
        handler.timersUpdated,
        [],
      ),
    );
  }
  return subscriptions;
};
